<template>
    <div>
      <h2>{{ title }}</h2>
      <loading :active.sync="isLoading" :is-full-page="true"></loading>
      <template>
        <v-system-bar class="branch-data">
          <v-spacer></v-spacer>
          <div v-on:keypress.enter.prevent="getOnlineExhibitionTable(1)">
            <input-search
              :model="search" @update="searchInput"/>
          </div>
          <circle-button
            v-if="permissionOnlineExhibition && permissionOnlineExhibition.permission_id === permission.readWrite"
            @click.native="createData"/>
        </v-system-bar>
      </template>
      <template>
        <v-simple-table class="branch-data">
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable(header.name)">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort_date == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort_date == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in dataTable">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{item.branch ? item.branch.branch_name_en : ''}}</td>
              <td width="35%">{{item.title_en}}</td>
              <td align="center">{{item.template_id}}</td>
              <td>{{item.publish_date | moment('DD-MM-YYYY')}}</td>
              <td>{{item.edit_date | moment('DD-MM-YYYY')}}</td>
              <td>
                <a @click="showData(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
      <paginate :length="dataPaginate.last_page"
                :page="dataPaginate.current_page"
                @update="changePage">
      </paginate>
    </div>
</template>

<script>
    import InputSearch from "../../../components/Input/InputSearch";
    import CircleButton from "../../../components/Button/CircleButton";
    import IconPencil from "../../../components/Icon/icon-pencil";
    import Paginate from "../../../components/Layout/Paginate";
    import {permissionOnlineExhibition, role} from "../../../util/Permission";
    import {mapState} from "vuex";
    import Loading from 'vue-loading-overlay';
    import Swal from "sweetalert";
    export default {
        name: "OnlineExhibitionTable",
      components: {Paginate, IconPencil, CircleButton, InputSearch, Loading},
      data(){
          return{
            title : 'Online Exhibition',
            isLoading : false,
            headers : [
              {id : 1 , text : 'No.',icon : null, name: null},
              {id : 2 , text : 'Branch',icon : null, name: null},
              {id : 3 , text : 'Title',icon : null, name: null},
              {id : 4 , text : 'Template',icon : null, name: null},
              {id : 5 , text : 'Publish date',icon : true,name: "edit_date"},
              {id : 6 , text : 'Edit date',icon : true,name: "edit_date"},
              {id : 7 , text : 'Edit',icon : null, name: null},
            ],
            dataTable : [],
            dataPaginate: {
              current_page: 1,
              from: 1,
              last_page: 1,
              per_page: 1,
              total: 1,
              to: 1
            },
            permission : null,
            search : '',
            sort_date : 'desc',
            sort_column : null,
          }
        },
      created() {
        this.getOnlineExhibitionTable(1);
        this.permission = role;
      },
      computed: {
        permissionOnlineExhibition,
      },
      methods:{
        getOnlineExhibitionTable(page){
          this.isLoading = true;
          this.$store.dispatch("OnlineExhibition/getOnlineExhibition",{
            page,
            search : this.search,
            sort_date : this.sort_date,
            sort_column : this.sort_column
          }).then(res=>{
            if(res.response_code == 200){
             this.dataTable = res.result.data;
              this.dataPaginate = {
                current_page: res.result.current_page,
                from: res.result.from,
                last_page: res.result.last_page,
                per_page: res.result.per_page,
                total: res.result.total,
                to: res.result.to
              }
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot request data','error');
            this.isLoading = false;
          })
        },
        async changePage(val){
          this.isLoading = true;
          this.dataPaginate.current_page = val;
          await this.getOnlineExhibitionTable(this.dataPaginate.current_page);
          this.isLoading = false;
        },
        goToExhibitionEdit(){
          this.$router.push("/online-exhibition/edit");
        },
        createData(){
          this.$store.dispatch("OnlineExhibition/clearFormData").then(()=>{
            this.goToExhibitionEdit();
          })
        },
        showData(id){
          this.isLoading = true;
          this.$store.dispatch("OnlineExhibition/showOnlineExhibition",id).then(res=>{
            if(res.response_code == 200){
              this.$store.dispatch("OnlineExhibition/setFormOnlineExhibition",res.result).then(()=>{
                this.goToExhibitionEdit();
              })
            }else{
              Swal(res.response_msg);
            }
            this.isLoading = false;
          }).catch(()=>{
            Swal('','Cannot request data','error');
            this.isLoading = false;
          })
        },
        searchInput(val){
          this.search = val;
        },
        sortDataTable(val){
          this.sort_column = val ? val : '';
          this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
          this.getOnlineExhibitionTable(1);
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/variables.scss";
  .branch-data {
    background-color: $background-theme;
    margin: $margin-search;
  }
</style>
